import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpimprichichwad() {



  const cardData =
  {
    keyword: 'Bus On Rent in Pimpri Chinchwad',
    heading: 'Amruta Travels: Bus On Rent in Pimpri Chinchwad',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers reliable and comfortable Bus on Rent in Pimpri Chinchwad, ideal for corporate tours, school picnics, weddings, family outings, and outstation trips. Our fleet includes a variety of AC, Non-AC, and luxury buses ranging from 17-seater minibuses to 53-seater coaches, ensuring the right fit for every group size and occasion. Each bus features push-back seats, efficient air conditioning, spacious interiors, and ample luggage capacity for a relaxed journey. Operated by skilled and courteous chauffeurs, we guarantee punctual, safe, and hassle-free travel across Nigdi, Chinchwad, Wakad, Hinjewadi, and Talegaon. For dependable and affordable group transportation, Amruta Travels’ Bus Rental in Pimpri Chinchwad is the trusted choice for comfort, convenience, and quality service.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Bus On Rent in Pimpri Chinchwad",
      "description": "Bus On Rent in Pimpri Chinchwad provides a wide range of buses for rent suitable for all types of group travel including corporate events, family outings, and school trips. The service ensures well-maintained vehicles with professional drivers who prioritize safety and punctuality. Flexible rental plans and competitive pricing make it a convenient choice for residents and businesses in Pimpri Chinchwad."
    },
    {
      "name": "Bus Hire Pimpri Chinchwad",
      "description": "Bus Hire Pimpri Chinchwad specializes in renting buses tailored to local travel needs. From daily commutes to special occasions, the fleet includes AC and Non-AC buses, mini buses, and luxury coaches. Customers benefit from timely service, clean and comfortable vehicles, and experienced drivers familiar with Pimpri Chinchwad’s traffic patterns, ensuring smooth and efficient transportation."
    },
    {
      "name": "Bus Rental Pimpri Chinchwad",
      "description": "Bus Rental Pimpri Chinchwad offers reliable group transport solutions for the Pimpri Chinchwad area, catering to schools, corporate groups, and social events. The service features well-maintained buses with ample seating and luggage space, driven by courteous professionals. Flexible booking options and affordable rates make this a popular choice for hassle-free group travel."
    },
    {
      "name": "AC Bus Pimpri Chinchwad",
      "description": "AC Bus Pimpri Chinchwad ensures a comfortable and cool travel experience with fully air-conditioned buses ideal for Pune’s warm climate. These buses are perfect for corporate trips, weddings, and long-distance journeys, equipped with modern AC systems and spacious interiors. Professional drivers focus on passenger comfort and safety to provide a premium travel experience."
    },
    {
      "name": "Non AC Bus Pimpri Chinchwad",
      "description": "Non AC Bus Pimpri Chinchwad offers economical transportation options without air conditioning, suitable for budget travelers and short intra-city trips. Despite the absence of AC, these buses maintain high standards of cleanliness, safety, and comfort. Skilled drivers ensure punctual pickups and smooth rides, making it an accessible and practical choice for many groups."
    },
    {
      "name": "Mini Bus Hire Pimpri Chinchwad",
      "description": "Mini Bus Hire Pimpri Chinchwad caters to smaller groups requiring flexible and convenient transport solutions. These mini buses are ideal for family outings, office commutes, and local tours. Well-maintained vehicles combined with experienced drivers guarantee timely service and a comfortable travel experience tailored to the diverse needs of Pimpri Chinchwad residents."
    },
    {
      "name": "Luxury Bus Hire Pimpri Chinchwad",
      "description": "Luxury Bus Hire Pimpri Chinchwad offers upscale buses with premium interiors, advanced amenities, and enhanced seating comfort. Designed for weddings, corporate events, and special occasions, these luxury buses feature elegant finishes and attentive chauffeurs who provide discreet and exceptional service. This service aims to deliver a sophisticated and memorable travel experience."
    },
    {
      "name": "School Bus Hire Pimpri Chinchwad",
      "description": "School Bus Hire Pimpri Chinchwad focuses on safe and reliable transportation for students. These buses adhere to strict safety protocols, are regularly maintained, and driven by trained drivers familiar with school routes. The service supports daily school runs as well as educational trips, ensuring peace of mind for parents and schools alike."
    },
    {
      "name": "Corporate Bus Hire Pimpri Chinchwad",
      "description": "Corporate Bus Hire Pimpri Chinchwad provides tailored transport solutions for businesses, including employee shuttles, client visits, and corporate events. The fleet comprises clean, comfortable buses driven by professional chauffeurs who respect company schedules and prioritize timely arrivals. Flexible rental options accommodate varying corporate needs efficiently."
    },
    {
      "name": "Wedding Bus Hire Pimpri Chinchwad",
      "description": "Wedding Bus Hire Pimpri Chinchwad offers elegant and spacious buses to transport wedding guests with style and comfort. Customizable decoration options and attentive drivers ensure seamless logistics on your special day. This service aims to add convenience and luxury to wedding transportation, enhancing the overall celebration experience."
    },
    {
      "name": "Bus Hire in Wakad",
      "description": "Bus Hire in Wakad serves the Wakad locality with reliable bus rental options for various group travel needs. Whether it’s corporate outings, school trips, or social events, this service offers clean vehicles, professional drivers, and flexible booking, ensuring punctual and safe transportation within Wakad and surrounding areas."
    },
    {
      "name": "Bus Hire in Nigdi",
      "description": "Bus Hire in Nigdi provides dependable bus rental services catering to the Nigdi region. From daily commutes to special occasions, the service features a range of buses including AC, Non-AC, and luxury coaches. Experienced drivers ensure a comfortable and timely journey, with vehicles maintained to high safety and cleanliness standards."
    },
    {
      "name": "Bus Hire in Bhosari",
      "description": "Bus Hire in Bhosari offers comprehensive bus rental services tailored for group travel within and beyond Bhosari. This service provides a fleet of well-maintained buses with experienced chauffeurs, focusing on safety, reliability, and customer satisfaction. Ideal for corporate, educational, and leisure travel needs in the Bhosari area."
    },
    {
      "name": "Bus Hire near Me Pimpri",
      "description": "Bus Hire near Me Pimpri provides quick and easy access to bus rental services in the vicinity. Emphasizing fast response times and professional drivers, this service ensures that well-maintained buses are available for immediate or scheduled group travel throughout Pimpri Chinchwad. It simplifies booking and enhances convenience for local travelers."
    },
    {
      "name": "Affordable Bus Pimpri Chinchwad",
      "description": "Affordable Bus Pimpri Chinchwad focuses on providing cost-effective group transportation solutions without compromising on safety or quality. This service is ideal for budget-conscious customers including schools, small businesses, and families. Transparent pricing, reliable vehicles, and flexible booking options make it a trusted choice for economical travel in Pimpri Chinchwad."
    },
    {
      "name": "Tourist Bus Hire Pimpri",
      "description": "Tourist Bus Hire Pimpri caters to travelers and tour groups seeking comfortable and spacious buses for sightseeing and leisure trips around Pimpri and nearby attractions. These buses feature ample seating, large luggage capacity, and knowledgeable drivers who ensure an enjoyable and informative travel experience tailored to tourists’ needs."
    },
    {
      "name": "Volvo Bus Hire PCMC",
      "description": "Volvo Bus Hire PCMC offers premium Volvo buses known for their superior comfort, safety features, and smooth rides. Ideal for long-distance travel, corporate outings, and luxury group tours, these buses come equipped with modern amenities and professional drivers ensuring punctual and comfortable journeys within and beyond PCMC limits."
    },
    {
      "name": "Party Bus Hire Pimpri",
      "description": "Party Bus Hire Pimpri provides specially equipped buses designed to host celebrations on the move. These buses feature entertainment systems, comfortable seating arrangements, and vibrant lighting, perfect for birthdays, bachelor parties, and other social events. Professional drivers ensure safe travel while guests enjoy a fun and lively party atmosphere."
    }
  ],
  "tableData": [
    ["Bus On Rent in Pimpri Chinchwad", "Bus Hire Pimpri Chinchwad"],
    ["Bus Rental Pimpri Chinchwad", "AC Bus Pimpri Chinchwad"],
    ["Non AC Bus Pimpri Chinchwad", "Mini Bus Hire Pimpri Chinchwad"],
    ["Luxury Bus Hire Pimpri Chinchwad", "School Bus Hire Pimpri Chinchwad"],
    ["Corporate Bus Hire Pimpri Chinchwad", "Wedding Bus Hire Pimpri Chinchwad"],
    ["Bus Hire in Wakad", "Bus Hire in Nigdi"],
    ["Bus Hire in Bhosari", "Bus Hire near Me Pimpri"],
    ["Affordable Bus Pimpri Chinchwad", "Tourist Bus Hire Pimpri"],
    ["Volvo Bus Hire PCMC", "Party Bus Hire Pimpri"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides reliable and comfortable bus rental services in Pimpri Chinchwad, ideal for group travel, corporate outings, and special events."
  },
  {
    "WhyChooseheading": "Variety of Bus Sizes Available",
    "WhyChoosedescription": "Choose from a wide range of buses, including 17, 35, 45, 50, and 53 seater options to fit your group size and travel needs."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our buses are regularly serviced and sanitized to ensure a safe, hygienic, and comfortable journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront pricing with no hidden charges, providing excellent value for your rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Select from hourly, daily, or long-term rentals customized to your specific travel requirements."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are trained to ensure safe, punctual, and pleasant travel experiences."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated customer service team is available around the clock to assist with bookings, inquiries, and travel assistance."
  },
  {
    "WhyChooseheading": "Quick and Hassle-Free Booking",
    "WhyChoosedescription": "Book your bus rental easily online or by phone, with prompt vehicle delivery anywhere in Pimpri Chinchwad."
  }
]




























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus rental services in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides buses on rent in Pimpri Chinchwad, catering to various group travel needs.',
  },
  {
    question: 'How can I book a bus in Pimpri Chinchwad with Amruta Travels?',
    answer: 'Booking is simple via our website, mobile app, or by contacting our 24×7 customer support team in Pimpri Chinchwad.',
  },
  {
    question: 'What types of buses are available for rent in Pimpri Chinchwad?',
    answer: 'We offer mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to meet your requirements.',
  },
  {
    question: 'Are the drivers trained and experienced for bus rentals in Pimpri Chinchwad?',
    answer: 'Yes, our drivers are professional, courteous, and skilled in safely driving buses of various sizes in Pimpri Chinchwad.',
  },
  {
    question: 'Can buses be rented for weddings, corporate events, tours, and airport transfers in Pimpri Chinchwad?',
    answer: 'Absolutely. Our buses are suitable for weddings, corporate outings, sightseeing tours, airport transfers, and other group travel needs.',
  },
  {
    question: 'Is the bus rental service available 24×7 in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels offers 24×7 bus rental services in Pimpri Chinchwad to fit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for bus rentals?',
    answer: 'All vehicles are sanitized thoroughly before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for bus rental in Pimpri Chinchwad?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the bus rental period in Pimpri Chinchwad?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Kulkarni',
    feedback: 'The bus from Amruta Travels Pimpri Chinchwad was clean and comfortable. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent bus rental experience with Amruta Travels Pimpri Chinchwad. Highly recommended for group travel.',
    rating: 5,
  },
];


































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pimpri Chinchwad",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/14.jpg",
  "description": "Book Bus On Rent in Pimpri Chinchwad with Amruta Travels Pvt. Ltd. offering AC, Non-AC, Luxury, Mini, and Volvo buses for corporate events, weddings, school trips, and party bus services. Affordable and reliable bus rental in Pimpri Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.75",
    "ratingCount": "14800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3300",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-on-rent-in-pimpri-chinchwad"
  }
};



  return (
    <div>
<Helmet>
  <title>Bus On Rent in Pimpri Chinchwad | AC, Luxury & Mini Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Bus On Rent in Pimpri Chinchwad with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, Luxury, Mini, and Volvo buses for corporate, wedding, school, and party trips. Affordable and trusted bus rental in Pimpri Chinchwad."
  />
  <meta
    name="keywords"
    content="Bus On Rent in Pimpri Chinchwad, Bus Hire Pimpri Chinchwad, Bus Rental Pimpri Chinchwad, AC Bus Pimpri Chinchwad, Non AC Bus Pimpri Chinchwad, Mini Bus Hire Pimpri Chinchwad, Luxury Bus Hire Pimpri Chinchwad, School Bus Hire Pimpri Chinchwad, Corporate Bus Hire Pimpri Chinchwad, Wedding Bus Hire Pimpri Chinchwad, Bus Hire in Wakad, Bus Hire in Nigdi, Bus Hire in Bhosari, Bus Hire near Me Pimpri, Affordable Bus Pimpri Chinchwad, Tourist Bus Hire Pimpri, Volvo Bus Hire PCMC, Party Bus Hire Pimpri"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinpimprichichwad;